export var AI_FLOW_MESSAGE = /* @__PURE__ */ ((AI_FLOW_MESSAGE2) => {
  AI_FLOW_MESSAGE2["HUMAN"] = "human";
  AI_FLOW_MESSAGE2["AI"] = "ai";
  AI_FLOW_MESSAGE2["SYSTEM"] = "system";
  AI_FLOW_MESSAGE2["TOOL"] = "tool";
  return AI_FLOW_MESSAGE2;
})(AI_FLOW_MESSAGE || {});
